export default __webpack_public_path__ + "static/Taco-Bell-logo.png";